import { Alert, Button, FormField, Spinner } from "@prequel/shared-components";

import { FormState } from "../LoginCard";

import { useCheckSSOEnabled, useSSOLogin } from "@/api/queries/auth";

type SsoCardProps = {
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
};

const SsoCard = ({ setFormState, email, setEmail }: SsoCardProps) => {
  const ssoLogin = useSSOLogin();
  const checkSSOEnabled = useCheckSSOEnabled();

  const onLoginWithSSO = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    ssoLogin.mutate(email);
  };

  return (
    <form onSubmit={onLoginWithSSO} className="space-y-4">
      <FormField
        id="email"
        key="email"
        type="email"
        placeholder="you@yourcompany.com"
        value={email}
        label="Email"
        onChangeHandler={setEmail}
        required
        autoFocus
      />

      {!ssoLogin.isPending && !ssoLogin.isSuccess && (
        <Button className="w-full" submit disabled={checkSSOEnabled.isPending} text={"Sign in with SSO"} />
      )}

      {(ssoLogin.isPending || ssoLogin.isSuccess) && (
        <Button
          className="w-full"
          disabled
          text={
            <div className="flex space-x-2.5">
              <Spinner.Inline className="mr-3" />
              <span>Sending to SSO</span>
            </div>
          }
        />
      )}

      {ssoLogin.isError && <Alert>SSO is not enabled for this account.</Alert>}

      <div className="flex justify-center text-sm text-gray-500">
        <a
          className="
            cursor-pointer text-primary-600
            hover:underline
          "
          onClick={() => setFormState("NOTHING_SELECTED")}
        >
          Back to other options
        </a>
      </div>
    </form>
  );
};

export default SsoCard;
